export default __webpack_public_path__ + "static/1111-by-kevin-abosch-0ca0a8045956dc90a3abe68d1dc26398.png";